import { connect } from 'react-redux'
import Introduction from './introduction'
import { getConflicts } from '../../../../../../stores/conflict-resolution/conflict-resolution.selectors'
import { setStep } from '../../../../../../stores/conflict-resolution/conflict-resolution.actions'

const mapStateToProps = state => {
  const conflicts = getConflicts(state)
  return {
    remainingStudents: conflicts && conflicts.remaining,
    importedStudentsCount: conflicts && conflicts.imported_students_count
  }
}

const mapDispatchToProps = dispatch => ({
  onNextStep: step => dispatch(setStep(step))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Introduction)
